






























































































import Vue from 'vue';
// tslint:disable-next-line:variable-name
const CurrencyFormat = (num: number): string => {
    const arr: string[] = [];
    let s = num.toString();
    while(s.length) {
        arr.unshift(s.slice(-3));
        s = s.slice(0,-3);
    }
    return '$' + `${arr.join(',')}`;
};

import Cast from '@components/Cast.vue';

import moment from 'moment';

interface reviewInterface {
    id: string;
    author: string;
    content: string;
    url: string;
}

interface dataInterface {
    id?: string;
    details?: Movie.Details;
    cast: Movie.Cast[];
    castPage: number;
    reviews: reviewInterface[];
    loading: boolean;
    has_errors: boolean;
}
export default Vue.extend({
    components: {
        Cast
    },
    created() {
        this.$tmdb.get('movie/'+ this.id, {
            params: {
                append_to_response: 'credits,reviews'
            }
        }).then(({ data })=> {
            this.details = data;
            this.cast = data.credits.cast;
            this.reviews = data.reviews.results;
            this.loading = false;
        }).catch((err)=> {
            this.loading = false;
            this.has_errors = true;
            console.error(err);
        });
    },
    computed: {
        // Returns a background image url for use with the style tag
        backgroundImage(): string {
            return 'url(' + this.$tmdb.buildImageUri(this.details!.backdrop_path, 'w1280') + ')';
        },
        // Returns the budget in USD
        budgetUsd(): string {
            return CurrencyFormat(this.details!.budget || 0);
        },
        // Total cast pages.
        totalCastPages(): number {
            return Math.ceil(this.castWithImages.length / 4 );
        },
        // Total cast that have images.
        castWithImages(): Movie.Cast[] {
            return this.cast.filter((member)=> member.profile_path);
        },
        // The current cast.
        currentCast(): Movie.Cast[] {
            return this.castWithImages.slice((this.castPage - 1) * 4, this.castPage * 4);
        },
        releaseDate(): string {
            if(!this.details) return '';
            const releaseDate = moment(this.details.release_date);
            return releaseDate.format('MMMM DD, YYYY');
        }
    },
    data(): dataInterface {
        return {
            id: this.$route.params.id,
            details: {
                adult: false,
                backdrop_path: '',
                belongs_to_collection: {},
                poster_path: '',
                budget: 0,
                release_date: ''
            },
            cast: [],
            castPage: 1,
            reviews: [],
            loading: true,
            has_errors: false
        };
    },
    beforeRouteUpdate(to,from,next) {
        if(to.name !== 'movie-details') return;
        this.loading = true;
        this.$tmdb.get('movie/'+ to.params.id, {
            params: {
                append_to_response: 'credits,reviews'
            }
        }).then(({ data })=> {
            this.details = data;
            this.cast = data.credits.cast;
            this.reviews = data.reviews;
            this.loading = false;
            this.id = to.params.id;
        }).catch((err)=> {
            this.loading = false;
            this.has_errors = true;
            console.error(err);
        });

        next();
    },
    methods: {
        strToParagraphs(str: string): string {
            if(str.indexOf('<script') !== -1) return console.error('CANNOT RENDER SCRIPT TAGS'),'';
            return str.replace(/^(.+)$/mg, '<p>$1</p>');
        },
        goToSection(sectionId: string) {
            const el = document.querySelector('#'+sectionId);
            if(!el) return;
            console.log(el);
            el.scrollIntoView();
        },
        buildProfileUri(image: string): string {
            return this.$tmdb.buildImageUri(image, 'w300');
        }
    }
});
